import { addClassNamesToElement } from "@lexical/utils";
import {
    $applyNodeReplacement,
    DOMExportOutput,
    EditorConfig,
    LexicalEditor,
    LexicalNode,
    SerializedTextNode,
    TextNode,
} from "lexical";

const CUSTOM_ACTION_NAME_NODE_TYPE = "custom-action-name-node";

type SerializedCustomActionNameNode = SerializedTextNode;

export class CustomActionNameNode extends TextNode {
    static getType(): string {
        return CUSTOM_ACTION_NAME_NODE_TYPE;
    }

    static clone(node: CustomActionNameNode): CustomActionNameNode {
        return new CustomActionNameNode(node.__text, node.__key);
    }

    static importJSON(serializedNode: SerializedTextNode): CustomActionNameNode {
        const node = $createCustomActionNameNode(serializedNode.text);
        node.setStyle(serializedNode.style);
        return node;
    }

    createDOM(config: EditorConfig): HTMLElement {
        const element = super.createDOM(config);
        addClassNamesToElement(element, config.theme.customActionNameVariable);
        return element;
    }

    exportDOM(editor: LexicalEditor): DOMExportOutput {
        const { element } = super.exportDOM(editor);
        // we don't want to highlight in purple the values
        // of the custom variables, just the variable names
        // so we remove the `class` attribute from the node
        // when we serialize this node to an HTML preview
        (element as HTMLElement).removeAttribute("class");
        return { element };
    }

    exportJSON(): SerializedCustomActionNameNode {
        return {
            ...super.exportJSON(),
            type: CUSTOM_ACTION_NAME_NODE_TYPE,
        };
    }

    canInsertTextBefore(): boolean {
        return false;
    }

    canInsertTextAfter(): boolean {
        return false;
    }

    supportsAutocomplete(): boolean {
        return true;
    }
}

export function $createCustomActionNameNode(text: string): CustomActionNameNode {
    const customVariableNode = new CustomActionNameNode(text);
    return $applyNodeReplacement(customVariableNode);
}

export function $isCustomActionNameNode(node: LexicalNode | null | undefined): node is CustomActionNameNode {
    return node instanceof CustomActionNameNode;
}
